import { cloneDeep, merge } from "lodash";
import { upsertOption } from "~/utilities/reducer";
import { checkIsMac } from "~/utilities/tableHelpers";

export const initialState = {
    useStickyScrollbar: false,
    verticalScrollExists: false,
    isMac: false,
    tableWrapperRef: null,
    isMobile: false,
};

export const setInitState = () => {
    const isMac = checkIsMac();

    return merge({}, initialState, {
        isMac,
    });
};

export const reducer = (state, action) => {
    let updatedState = cloneDeep(state);
    const {
        type,
        useStickyScrollbar,
        verticalScrollExists,
        tableWrapperRef,
        isMobile,
    } = action;

    switch (type) {
        case "SET_WRAPPER_REF":
            updatedState = upsertOption(updatedState, {
                tableWrapperRef,
            });
            break;
        case "SET_SCROLL_STATES":
            updatedState = upsertOption(updatedState, {
                useStickyScrollbar,
                verticalScrollExists,
            });
            break;
        case "UPDATE_SCREEN_SIZE":
            updatedState = upsertOption(updatedState, {
                isMobile,
            });
            break;
        default:
            break;
    }

    return updatedState;
};
